import Skeleton from 'react-loading-skeleton';
import { formatTimeDisplay, calculateDurationMinutes } from 'lib/timeHelpers';
import useImageFetcher from 'lib/hooks/useImageFetcher';

const ClassDetailAside = ({ data, scheduleDetailData, formatPickDate }) => {
  const { images, name } = data?.data?.class ?? {};
  const { imageUrls, loading } = useImageFetcher(images, true);

  return (
    <aside className="lg:sticky lg:top-20 col-span-4">
      <div className="rounded-2xl border bg-white shadow-sm overflow-hidden p-6">
        {/* Media */}
        <div>
          <div className="relative aspect-[3/2] w-full overflow-hidden rounded-2xl mb-2">
            {loading ? (
              <Skeleton height="100%" width="100%" className="rounded-2xl" />
            ) : (
              <img
                alt={name}
                src={imageUrls?.[0]}
                className="h-full w-full object-cover object-center transition-opacity duration-300"
              />
            )}
          </div>
          <div>
            <span className="mt-4 text-sm font-normal uppercase">{data?.data?.class?.subject}</span>
            <h3 className="text-lg font-bold leading-none max-h-[55px]">
              {data?.data?.class?.name || '-'}
            </h3>
            <span className="text-base font-semibold">{data?.data?.class?.theme || '-'}</span>
          </div>
        </div>

        <div>
          <div className="flex flex-col items-start gap-2">
            {/* Date */}
            <div className="flex flex-row items-center gap-2">
              <div className="w-4 h-4 relative">
                <img
                  alt="icon-calender"
                  src="/kin/assest/image/icon-calender.svg"
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </div>
              <span className="text-sm">
                {scheduleDetailData?.start_date
                  ? formatPickDate(scheduleDetailData.start_date)
                  : '-'}
              </span>
            </div>

            {/* Time */}
            <div className="flex flex-row items-center gap-2">
              <div className="w-4 h-4 relative">
                <img
                  alt="icon-clock"
                  src="/kin/assest/image/icon-clock.svg"
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </div>
              <span className="text-sm">
                {`${
                  scheduleDetailData?.start_time
                    ? formatTimeDisplay(scheduleDetailData.start_time)
                    : '-'
                } - ${
                  scheduleDetailData?.end_time
                    ? formatTimeDisplay(scheduleDetailData.end_time)
                    : '-'
                } (${calculateDurationMinutes(
                  scheduleDetailData?.start_time,
                  scheduleDetailData?.end_time,
                  scheduleDetailData?.class?.duration,
                )})`}
              </span>
            </div>

            {/* Classroom */}
            <div className="flex flex-row items-center gap-2">
              <div className="w-4 h-4 relative">
                <img
                  alt="icon-star"
                  src="/kin/assest/image/icon-star.svg"
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </div>
              <span className="text-sm capitalize ">
                Classroom {scheduleDetailData?.classroom?.name || '-'}
              </span>
            </div>

            {/* Teacher */}
            <div className="flex flex-row items-center gap-2">
              <div className="w-4 h-4 relative">
                <img
                  alt="icon-user"
                  src="/kin/assest/image/icon-user.svg"
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </div>
              <span className="text-sm capitalize ">
                {scheduleDetailData?.teacher?.name || '-'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default ClassDetailAside;
